var _metadata, _defs, _g, _mask, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.503012652681036 42.987095096898486",
    width: 43.503012652681036,
    height: 42.987095096898486,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.473823764883036 25.233660136161177) rotate(0 4.014594443899 3.8767174803686544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.34 1.29, 6.69 6.46, 8.03 7.75 M0 0 C1.34 1.29, 6.69 6.46, 8.03 7.75",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10 10) rotate(0 8.792539765022696 9.057010072023331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.59 9.06 C17.59 9.58, 17.54 10.11, 17.45 10.63 C17.36 11.15, 17.23 11.66, 17.05 12.15 C16.88 12.65, 16.66 13.13, 16.41 13.59 C16.15 14.04, 15.86 14.48, 15.53 14.88 C15.2 15.28, 14.83 15.66, 14.44 16 C14.05 16.33, 13.63 16.64, 13.19 16.9 C12.75 17.16, 12.28 17.39, 11.8 17.57 C11.32 17.75, 10.82 17.89, 10.32 17.98 C9.82 18.07, 9.3 18.11, 8.79 18.11 C8.28 18.11, 7.77 18.07, 7.27 17.98 C6.76 17.89, 6.26 17.75, 5.79 17.57 C5.31 17.39, 4.84 17.16, 4.4 16.9 C3.96 16.64, 3.53 16.33, 3.14 16 C2.75 15.66, 2.38 15.28, 2.06 14.88 C1.73 14.48, 1.43 14.04, 1.18 13.59 C0.92 13.13, 0.7 12.65, 0.53 12.15 C0.36 11.66, 0.22 11.15, 0.13 10.63 C0.05 10.11, 0 9.58, 0 9.06 C0 8.53, 0.05 8, 0.13 7.48 C0.22 6.97, 0.36 6.45, 0.53 5.96 C0.7 5.47, 0.92 4.98, 1.18 4.53 C1.43 4.07, 1.73 3.64, 2.06 3.24 C2.38 2.83, 2.75 2.46, 3.14 2.12 C3.53 1.78, 3.96 1.48, 4.4 1.21 C4.84 0.95, 5.31 0.73, 5.79 0.55 C6.26 0.37, 6.76 0.23, 7.27 0.14 C7.77 0.05, 8.28 0, 8.79 0 C9.3 0, 9.82 0.05, 10.32 0.14 C10.82 0.23, 11.32 0.37, 11.8 0.55 C12.28 0.73, 12.75 0.95, 13.19 1.21 C13.63 1.48, 14.05 1.78, 14.44 2.12 C14.83 2.46, 15.2 2.83, 15.53 3.24 C15.86 3.64, 16.15 4.07, 16.41 4.53 C16.66 4.98, 16.88 5.47, 17.05 5.96 C17.23 6.45, 17.36 6.97, 17.45 7.48 C17.54 8, 17.56 8.79, 17.59 9.06 C17.61 9.32, 17.61 8.79, 17.59 9.06",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.adf9f2f674b3cdfff198cd22356c6e17.svg";
export { ForwardRef as ReactComponent };